export const TEST_ID = 'serviceIntervalsModalHeader';

export const CLOSE_BUTTON_TEST_ID = 'serviceIntervalsModalHeaderCloseButton';
